import { DatePicker } from 'jalali-react-datepicker';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { PatientHeader } from '../components/PatientHeader';
import { Patient, ServiceItem } from '../redux/types';
import Axios from '../utils/axios';
import { enToFa } from '../utils/numbers';

type NewServicePatient = {
	patientId: string;
	serviceId?: string;
	amount?: number;
	date?: string;
};

type Payment = {
	id: string;
	name: string;
	amount: number;
	date: string;
};

type Payments = {
	payments: Payment[];
	total: number;
};

const PatientService: React.FunctionComponent = () => {
	const { id } = useParams<{ id: string }>();
	const [patient, setPatient] = useState<Partial<Patient>>({ id });
	const [services, setServices] = useState<ServiceItem[]>([]);
	const [newService, setNewService] = useState<NewServicePatient>({
		patientId: id,
		date: new Date().toISOString().split('T')[0]
	});

	const [payments, setPayments] = useState<Payments>({ payments: [], total: 0 });

	const addNewService = async () => {
		await Axios.post('/payment/', newService);
		getPaymentData();
	};
	async function getPaymentData() {
		const pres_data = await Axios.get(`/patient/${id}/payments`);
		const data = pres_data.data as unknown as Payments;
		setPayments(data);
	}
	useEffect(() => {
		async function fetchUserData() {
			const pres_data = await Axios.get(`/patient/${id}`);
			const data = pres_data.data;

			setPatient({
				firstName: data.first_name,
				lastName: data.last_name,
				tel: data.tel,
				id: data.id,
				created: data.created
			});
		}

		async function fetchServiceData() {
			const pres_data = await Axios.get(`/service/`);
			const data = pres_data.data;

			setServices(data);
			setNewService({
				...newService,
				serviceId: data[0].id,
				amount: data[0].price
			});
		}

		fetchUserData();
		fetchServiceData();
		getPaymentData();
	}, [id]);

	const getPrice = (id: string): number => {
		const service = services.find((item) => item.id === id);
		if (service) {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			return service.price!;
		}
		return 0;
	};
	const removePayment = async (id: string) => {
		await Axios.delete(`/payment/${id}`);
		const newPayments = payments.payments.filter((item) => item.id !== id);
		setPayments({ payments: newPayments, total: payments.total });
		getPaymentData();
	};

	return (
		<div>
			<datalist id="services"></datalist>
			{patient.firstName && (
				<PatientHeader
					firstName={patient.firstName}
					lastName={patient.lastName}
					tel={patient.tel}
					id={id}
					created={patient.created}
				/>
			)}

			<div className="p-3 mx-10 mt-5 rounded bg-blue-320">
				{/* add input for date , service(select) and price */}
				<div className="flex flex-col gap-5 text-center md:justify-start md:flex-row">
					<label className="text-gray-100 ">تاریخ: </label>
					<DatePicker
						className="w-full p-2 text-center border border-gray-300 rounded shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
						timePicker={false}
						onClickSubmitButton={async ({ value }) => {
							setNewService({
								...newService,
								date: value.format('YYYY-MM-DD')
							});
						}}
					/>
					<label className="text-center text-gray-100">خدمت: </label>
					<select
						className="px-5 text-center border border-gray-300 rounded shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
						value={newService.serviceId}
						onChange={(e) => {
							setNewService({
								...newService,
								serviceId: e.target.value,
								amount: getPrice(e.target.value)
							});
						}}
					>
						{services.map((service) => (
							<option key={service.id} value={service.id}>
								{service.name}
							</option>
						))}
					</select>
					<label className="text-center text-gray-100">هزینه: </label>
					<input
						className="text-center border border-gray-300 rounded shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
						type="number"
						value={newService.amount}
						onChange={(e) => {
							setNewService({ ...newService, amount: parseInt(e.target.value) });
						}}
					/>
					<button
						className="px-5 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700"
						onClick={addNewService}
					>
						ثبت
					</button>
				</div>

				{/* a table for payments */}
				<div className="mt-5">
					<table className="w-full text-center text-gray-100 rounded-lg shadow-md bg-cyan-700">
						<thead className=" bg-cyan-800">
							<tr className="p-2 m-1 rounded-lg">
								<th>ردیف</th>

								<th>تاریخ</th>
								<th>خدمت</th>
								<th>هزینه</th>
								<th>عملیات</th>
							</tr>
						</thead>
						<tbody>
							{payments.payments.map((payment, index) => (
								<tr key={payment.id} className=" odd:bg-cyan-600">
									<td>{enToFa(index + 1)}</td>
									<td>{new Date(payment.date).toLocaleDateString('fa-IR')}</td>
									<td>{payment.name}</td>
									<td>{payment.amount}</td>
									<td
										onClick={() => removePayment(payment.id)}
										className="text-red-800 cursor-pointer hover:text-red-600"
									>
										حذف
									</td>
								</tr>
							))}
						</tbody>
					</table>
					<div className="text-right text-gray-100">مجموع دریافتی: {payments.total} تومان</div>
				</div>
			</div>
		</div>
	);
};

export default PatientService;
